import React from "react";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

export default function RefundPolicy() {
  const { t } = useTranslation();

  return (
    <main className="legal-page">
      <h1 className="legal-page__title">{t('policy.refund.title')}</h1>
      <p className="legal-page__intro">{t('policy.refund.content_intro')}</p>
      <div className="legal-page__body" dangerouslySetInnerHTML={{ __html: t('policy.refund.body') }} />
    </main>
  );
}
